import React from 'react';
import PropTypes from 'prop-types';
import ProductTilePricing from './ProductTilePricing';
import {translateResourceString} from '../../../util/translationUtility';

class ProductTile extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            defaultVariationSku,
            name,
            status,
            url,
            priceViewModel,
            image,
            canAddToCart,
            onClick,
            onAddToCartClick,
            isUserLoggedIn,
            loginLink,
            description,
            sku,
            contactUsLink,
            showStatus
        } = this.props;

        return (
            <div className="product-tile">
                <div className="product-tile-inner">
                    {(showStatus && !!status && status != "Available") &&
                    <div className="item-status">
                        {status}
                    </div>
                    }
                    <div className="item-image">
                        <a
                            title={name}
                            href={url}
                            onClick={onClick}
                            style={{backgroundImage: "url('" + image.Url + "')"}}
                        >
                        </a>
                    </div>
                    <div className="item-content-wrapper">
                        <div data-bv-show="inline_rating" data-bv-product-id={defaultVariationSku} data-bv-redirect-url={url}></div>
                        <div className="item-name mb-2">
                            <a
                                title={name}
                                href={url}
                                onClick={onClick}
                                className="text-sm"
                            >
                                <span>{name}</span>
                            </a>
                        </div>
                        <div className="item-price">
                            {isUserLoggedIn && priceViewModel != null && priceViewModel.ShowPrice &&
                                <ProductTilePricing
                                    regularPrice={priceViewModel.RegularPrice}
                                    salePrice={priceViewModel.SalePrice}
                                />
                            }

                        </div>
                        {!isUserLoggedIn
                            ?
                            <div className="product-list-item-controls">
                                <a className="btn btn-cc-black btn-block" href={loginLink}>
                                    <span>{translateResourceString("/SearchApp/LoginToBuy")}</span>
                                </a>
                            </div>
                            :
                            <React.Fragment>
                                {canAddToCart
                                    ?
                                    <div className="product-list-item-controls add-to-cart-wrapper mt-2">
                                        <a className="btn btn-cc-black btn-block" href="#" type="button"
                                           onClick={(e) => onAddToCartClick(defaultVariationSku,e)}>
                                            <span>{translateResourceString("/SearchApp/AddToCart")}</span>
                                        </a>
                                    </div>
                                    :
                                    <React.Fragment>
                                        {priceViewModel == null || !!!priceViewModel.ShowPrice &&
                                            <div className="product-list-item-controls">
                                                <a className="btn btn-cc-black btn-block" href={contactUsLink}>
                                                    <span>{translateResourceString("/SearchApp/ContactForPrice")}</span>
                                                </a>
                                            </div>
                                        }
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </div>
                </div>

            </div>);
    }
}


ProductTile.propTypes = {
    defaultVariationSku: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    url: PropTypes.string,
    priceViewModel: PropTypes.shape({
        RegularPrice: PropTypes.string,
        SalePrice: PropTypes.string,
        IsSalePrice: PropTypes.bool
    }),
    image: PropTypes.shape({
        Url: PropTypes.string,
        Alt: PropTypes.string
    }),
    onAddToCartClick: PropTypes.func,
    isUserLoggedIn: PropTypes.bool,
    loginLink: PropTypes.string,
    description: PropTypes.string,
    sku: PropTypes.string
};

export default ProductTile;